<template>
  <div class="gameSignUp">
    <HeadBar title="报名" />
    <div class="gameSignUpInfo">
      <div class="game-card">
        <h3 class="signUpTitle">
          <p class="mt-10">您正在报名：{{ matchName }}</p>
          <span class="redColor">{{ matchInfo.type === 1 ? "个人赛 - " : "团体赛 - " }}
          </span>
          {{ matchInfo.projectName }}项目
        </h3>
        <ul class="matchInfoBox">
          <li>比赛地点：{{ matchInfo.place }}</li>
          <li>比赛时间：{{ matchTime }}</li>
          <li>
            报名价格：<span class="redColor font20">{{ price > 0 ? price + "元/人" : "免费" }}
            </span>
          </li>
        </ul>
      </div>
      <p class="baomInfoTitle">报名资料信息：</p>

      <div class="signUpForm">
        <van-form @submit="onSubmit" @failed="onFailed">
          <!-- 选择所属的团队 -->
          <van-field readonly clickable class="bigTips" name="originTeam" label="选择所属团队" placeholder="选择所属团队"
            v-model="originTeam" @click="showTeamList = true" :rules="[{ required: true, message: '选择所属团队' }]"
            v-if="matchInfo.type !== 1 && teamIds" />
          <van-popup v-model="showTeamList" position="bottom">
            <van-picker show-toolbar :columns="teamListArr" @confirm="onChooseTeam($event)"
              @cancel="showTeamList = false" />
          </van-popup>

          <div class="formItemBox" v-for="(item, index) in formData" :key="index">
            <p class="baomTitle" v-if="matchInfo.type !== 1">
              <span>第{{ index + 1 }}个人报名</span>
              <!-- <span
                class="delBaoming"
                v-if="formData.length > 1 && index !== 0"
                @click="delBaomingData(index)"
                ><van-icon name="cross"
              /></span> -->
            </p>
            <!-- 姓名 -->
            <van-field v-model="formData[index].name" name="name" label="真实姓名" placeholder="真实姓名"
              :disabled="formData[index].disabledName" :rules="[{ required: true, message: '请填写真实姓名' }]" />

            <!-- 性别 -->
            <van-field name="sex" label="性别" :rules="[{ required: true, message: '请选择性别' }]">
              <template #input>
                <van-radio-group v-model="formData[index].sex" direction="horizontal"
                  :disabled="formData[index].readOnlySex || formData[index].disabledSex1">
                  <span class="mr5" v-if="formData[index].readOnlySex">此棒必须是{{formData[index].sex === "1" ? "男" :
                    "女"}}性</span>
                  <van-radio name="1" value="1">男</van-radio>
                  <van-radio name="2" value="2">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <!-- 手机号码 -->
            <van-field v-model="formData[index].tel" name="tel" label="手机号码" type="tel" placeholder="手机号码"
              :disabled="formData[index].disabledTel" :rules="[
                { validator, required: true, message: '请填写手机号码' },
              ]" />

            <!-- 证件类型 -->
            <van-field readonly clickable name="type" label="证件类型" placeholder="点击选择证件类型"
              :disabled="formData[index].disabledNumber" v-model="formData[index].type"
              @click="formData[index].showType = true" :rules="[{ required: true, message: '请选择证件类型' }]" />
            <van-popup v-if="!formData[index].type" v-model="formData[index].showType" position="bottom">
              <van-picker show-toolbar :columns="typeArr" @confirm="onType($event, index)"
                @cancel="formData[index].showType = false" @change="onChange($event, index)" />
            </van-popup>

            <!-- 证件号码 " -->
            <van-field v-model="formData[index].number" name="number" label="证件号码" placeholder="证件号码"
              @change="onNumberChange($event, index)" :disabled="formData[index].disabledNumber" :rules="[
                {
                  pattern: formData[index].pattern,
                  required: true,
                  message: '请填写正确的证件号码',
                },
              ]" />
            <van-field v-model="formData[index].birthday" is-link readonly name="birthday" label="出生年月日"
              placeholder="点击选择出生年月日" @click="formData[index].showPicker = true"
              :disabled="formData[index].disabledNumber" :rules="[{ required: true, message: '请选择出生年月日' }]" />
            <van-popup v-if="!formData[index].birthday" v-model="formData[index].showPicker" position="bottom">
              <van-datetime-picker type="date" title="选择出生年月日" :disabled="formData[index].disableBirthday"
                :min-date="minDate" :max-date="maxDate" @confirm="onConfirm($event, index)"
                @cancel="formData[index].showPicker = false" />
            </van-popup>
            <van-field v-model="projectCode" v-if="projectCode" name="name" label="赞助商邀请码" placeholder="赞助商邀请码" disabled
              class="redColor" :rules="[{ pattern: allPattern['其他'], required: true, message: '赞助商邀请码' }]" />
            <!-- 衣服尺码 -->
            <van-field readonly clickable name="dressSize" label="衣服尺码" placeholder="点击选择衣服尺码"
              v-model="formData[index].dressSize" @click="formData[index].showDressSize = true"
              :rules="[{ required: true, message: '请选择衣服尺码' }]" />
            <van-popup v-model="formData[index].showDressSize" position="bottom">
              <van-picker show-toolbar :columns="dressSizeArr" @confirm="onDressSize($event, index)"
                @cancel="formData[index].showDressSize = false" />
            </van-popup>

            <van-field v-model="formData[index].contactsName" name="name" label="紧急联系人" placeholder="紧急联系人"
              :rules="[{ required: true, message: '请填写紧急联系人' }]" />
            <van-field v-model="formData[index].contactsTel" name="tel" label="联系人号码" type="tel" placeholder="联系人号码"
              :rules="[{ validator, required: true, message: '联系人号码' }]" />

            <!-- 快递邮寄地址（省市区） -->
            <van-field readonly clickable name="area" label="地址选择" placeholder="点击选择省市区"
              :value="formData[index].areaString" @click="formData[index].showArea = true"
              :rules="[{ required: true, message: '请选择省市区' }]" />
            <van-popup v-model="formData[index].showArea" position="bottom">
              <van-area :area-list="areaList" @confirm="onConfirmAddress($event, index)"
                @cancel="formData[index].showArea = false" />
            </van-popup>
            <!--  快递邮寄详细地址-->
            <van-field v-model="formData[index].address" name="address" label="快递邮寄地址" placeholder="快递邮寄详细地址"
              :rules="[{ required: true, message: '请填写快递邮寄详细地址' }]" />
            <!-- 完赛证书 -->
            <van-field name="uploader" label="必须上传近期马拉松完赛证明(1MB以内)" class="bigTips"
              v-if="matchInfo.type === 1 && needPic && online == 0">
              <template #input>
                <van-uploader v-model="uploader" max-count="1" :after-read="afterRead" :max-size="1024 * 1024"
                  @oversize="onOversize" result-type="dataUrl" />
              </template>
            </van-field>
          </div>
          <div class="fixedBottomBar">
            <div class="redColor">
              总金额: {{ price > 0 ? price * formData.length + "元" : "免费" }}
            </div>
            <van-button class="submitBtn" type="danger" native-type="submit"
              :disabled="disabledSubmit">立即报名</van-button>
          </div>
        </van-form>
        <div class="addPeopleBox" v-if="showGetMyInfo">
          <!-- <van-button icon="plus" type="info" size="small" @click="addPeople">添加报名人数</van-button> -->
          <van-button class="ml10" icon="plus" type="primary" size="small" @click="oneKeyInfo">一键填写我的报名信息</van-button>
        </div>
        <div class="agreeBox">
          <van-checkbox checked-color="#ee0a24" v-model="checked" disabled shape="square">
            我已同意并阅读

            <div v-if="ifActive">
              <a href="newsDetail?newsId=123">《{{matchName}}报名须知》</a><a href="newsDetail?newsId=144">《{{matchName}}竞赛规程》</a>
            </div>
            <a v-else href="newsDetail?newsId=145">《赛事免责声明》</a>
          </van-checkbox>
        </div>
      </div>

      <!-- 参赛协议dialog -->
      <ActiveAgreement v-if="ifActive" @onAgree="onAgree" :show="showAgree"></ActiveAgreement>
      <Agreement v-else @onAgree="onAgree" :show="showAgree"></Agreement>

    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import ActiveAgreement from "@/components/ActiveAgreement.vue";
  // import ActiveAgreementJingyue from "@/components/ActiveAgreementJingyue.vue";
  import Agreement from "@/components/Agreement.vue";
  import { areaList } from "@vant/area-data";
  import { DatetimePicker, Dialog } from "vant";
  import { getQueryString, fetchHttp, formatTime } from "@/util/fn.js";
  import {
    Toast,
    Button,
    Form,
    Field,
    Radio,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Popup,
    Picker,
    Area,
    Uploader,
    SubmitBar,
  } from "vant";

  export default {
    name: "gameSignUp",
    components: {
      HeadBar,
      [Button.name]: Button,
      [Form.name]: Form,
      [Field.name]: Field,
      [Radio.name]: Radio,
      [RadioGroup.name]: RadioGroup,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [Area.name]: Area,
      [Uploader.name]: Uploader,
      [SubmitBar.name]: SubmitBar,
      [Checkbox.name]: Checkbox,
      [DatetimePicker.name]: DatetimePicker,
      Agreement,
      ActiveAgreement
    },
    data() {
      return {
        canSubmitForm: true,
        ifActive: window.location.pathname.includes('/active/'),
        ifActiveJingyue: false,
        disabledSubmit: false,
        allPattern: {
          身份证: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          护照: /^([a-zA-z]|[0-9]){5,17}$/,
          其他: /^([a-zA-z]|[0-9]){5,18}$/,
          mobile: /^1[3456789]\d{9}$/,
        },
        checked: true,
        matchTime: "",
        originTeam: "",
        showTeamList: false,
        teamIds: "",
        minDate: new Date(1923, 0, 1),
        maxDate: new Date(2023, 0, 1),
        formData: [
          {
            name: "",
            sex: "",
            birthday: "",
            readOnlySex: false,
            tel: "",
            type: "",
            pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            contactsTel: "",
            contactsName: "",
            showType: false,
            showPicker: false,
            disabledNumber: false,
            disabledName: false,
            disabledSex1: false,
            disabledTel: false,
            disableBirthday: false,
            showDressSize: false,
            showArea: false,
            number: "",
            dressSize: "",
            areaString: "",
            address: "",
            matchId: getQueryString("matchId"),
            projectId: getQueryString("projectId"),
            url: "",
          },
        ],
        username: "",
        userId: Cookies.get("USERID"),
        matchName: getQueryString("matchName"),
        matchId: getQueryString("matchId"),
        online: getQueryString("online"),
        projectId: getQueryString("projectId"),
        projectCode: getQueryString("projectCode"),
        price: getQueryString("price"),
        endTime: getQueryString("endTime"),
        showPrice: 0,
        matchInfo: {},
        areaList: areaList,
        bloodTypeArr: ["A", "B", "AB", "O", "其他"],
        dressSizeArr: ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
        teamListArr: [],
        typeArr: ["身份证", "护照", "其他"],
        uploader: [{ url: "" }],
        showAgree: true,
        showGetMyInfo: false,
        teamId: "",
        teamName: "",
        needPic: false,
      };
    },
    computed: {},
    mounted() {
      this.showPrice = this.price ? parseFloat(this.price) * 100 : 0;
      this.ifActiveJingyue =  getQueryString('type') === 'jingyue' ? true : false;
      console.log(this.ifActiveJingyue)
      //获取赛事详情
      this.getGameDetail();

    },
    methods: {
      showProjectCodeBox() {
        Dialog.confirm({
          title: " 特约赞助商",
          message: `您正在使用赞助商邀请码的方式进行报名，卡密为 ${this.projectCode} ，请确认是否使用！`,
        })
          .then(() => {
            //如果有邀请码逻辑
            if (this.projectCode) {
              fetchHttp("marathon/signUp/checkCode", { matchId: this.matchId, projectId: this.projectId, codes: this.projectCode }, "GET", "showError").then((res) => {
                if (res && res.code === 0) {
                  let codeData = res.data;
                  this.price = codeData.price;
                  Toast({
                    message: `邀请码校验成功，${codeData.price === '0.00' ? '已抵扣全部费用，' : ''}快去报名吧！`,
                    icon: 'success',
                    duration: 3500
                  });
                } else {
                  Toast({
                    message: res.message,
                    icon: 'cross',
                    duration: 3500
                  });
                  this.disabledSubmit = true;
                  setTimeout(() => {
                    window.location.href = 'index';
                  }, 4000)
                }
              })
            }
          })
          .catch(() => {
            setTimeout(() => {
              window.history.go(-1);
            }, 1500)
          });
      },
      formatSfzNumber(number) {
        let birthdayNum = number.slice(6, 10) + "-" + number.slice(10, 12) + "-" + number.slice(12, 14);
        return birthdayNum;
      },
      onNumberChange(event, index) {
        if (this.allPattern['身份证'].test(event.target.value)) {
          this.formData[index].birthday = this.formatSfzNumber(event.target.value);
          this.formData[index].disableBirthday = true;
        }
      },
      validator(val) {
        let numReg = /^1[3456789]\d{9}$/;
        return numReg.test(val);
      },
      disabledSex(sex) {
        if (sex === "1" || sex === "2") {
          return true;
        } else {
          return false;
        }
      },
      addPeople() {
        this.formData.push({
          name: "",
          sex: "",
          birthday: "",
          tel: "",
          type: "",
          pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          showType: false,
          showPicker: false,
          disabledNumber: false,
          disableBirthday: false,
          disabledName: false,
          disabledSex1: false,
          disabledTel: false,
          showDressSize: false,
          showArea: false,
          number: "",
          dressSize: "",
          areaString: "",
          address: "",
          matchId: getQueryString("matchId"),
          projectId: getQueryString("projectId"),
          url: "",
          teamId: "",
          readOnlySex: false,
          teamName: "",
          contactsTel: "",
          contactsName: "",
        });
        return false;
      },
      delBaomingData(index) {
        this.formData.splice(index, 1);
      },
      onDressSize(value, index) {
        this.formData[index].dressSize = value;
        this.formData[index].showDressSize = false;
      },
      onChooseTeam(value) {
        let index = this.originTeamArr.findIndex((item) => {
          return item.name === value;
        });
        this.originTeam = value;
        this.teamId = this.originTeamArr[index].id;
        this.teamName = value;
        this.showTeamList = false;
        this.teamTel = this.originTeamArr[index].teamTel;
        this.loginUser = Cookies.get("FMTY_USERDATA");
        this.teamOwnerName = this.originTeamArr[index].teamName;

        //判断是否限制队长报名
        if (this.onlyTeamOwner) {
          if (this.teamTel !== this.loginUser) {
            Toast(
              "该赛事限制只能由团队队长报名，请联系队长<<" +
              this.teamOwnerName +
              ">>来帮团队报名！"
            );
            this.refuseSubmit = true;
          } else {
            this.refuseSubmit = false;
          }
        }
      },
      onType(value, index) {
        this.formData[index].type = value;
        this.formData[index].showType = false;
        this.formData[index].pattern = this.allPattern[value];
      },
      getDate(date) {
        var time = new Date(date);
        var year = time.getFullYear(); //年
        var month = ("0" + (time.getMonth() + 1)).slice(-2); //月
        var day = ("0" + time.getDate()).slice(-2); //日
        var mydate = year + "-" + month + "-" + day;
        return mydate;
      },
      ///选择年月日
      onConfirm(value, index) {
        this.formData[index].birthday = this.getDate(value);
        this.formData[index].showPicker = false;
      },
      //更改证件类型
      onChange(event, index) {
        let value = event.getValues()[0];
        this.formData[index].type = value;
        this.formData[index].pattern = this.allPattern[value];
      },
      onConfirmAddress(values, index) {
        this.formData[index].areaString = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join("/");
        this.formData[index].showArea = false;
      },
      //取所属的团队信息
      getTeamListData(teams) {
        fetchHttp(
          "marathon/signUp/infoList",
          { ids: teams },
          "GET",
          "showError"
        ).then((res) => {
          if (res && res.code === 0) {
            if (res.data) {
              let data = res.data;
              let arrayData = [];
              data && data.length > 0
                ? data.map((item) => {
                  arrayData.push(item.name);
                })
                : "";
              this.teamListArr = arrayData;
              this.originTeamArr = data;
            }
          } else {
            Toast.fail(res.message);
          }
        });
      },
      onOversize(file) {
        Toast("完赛证明图片大小不能超过 1MB");
      },
      // 完赛证的 文件上传
      afterRead(file) {
        file.status = "uploading";
        file.message = "上传中...";

        //处理请求参数
        let formData = new FormData();
        formData.append("file", file.file);

        let postUrl = "http://ccfmty.com/marathon/picture";

        let postData = {
          method: "POST",
          credentials: "include",
          headers: {
            Accept: "*/*",
            token: Cookies.get("FMTY_TOKEN"),
          },
          body: formData,
        };
        let _self = this;
        window
          .fetch(postUrl, postData)
          .then(function (response) {
            return response.json();
          })
          .then(function (res) {
            if (res.code === 0 && res.data) {
              let url = "";
              if (res.data && res.data.includes("马拉松")) {
                url = "http://ccfmty.com/marathon" + res.data;
              } else {
                url = res.data;
              }
              _self.uploader = url ? [{ url: url }] : [];
            } else if (
              res.code === 300003 ||
              res.code === 300000 ||
              res.code === 300002
            ) {
              alert("登录失效，请您去登录！");
              setTimeout(() => {
                window.location.href =
                  "user" +
                  "?redirect_url=" +
                  encodeURIComponent(window.location.href);
              }, 2500);
            } else {
              file.status = "failed";
              file.message = "上传失败";
            }
          });
      },
      onFailed() {
        if (
          this.matchInfo &&
          this.matchInfo.type !== 1 &&
          this.teamIds &&
          !this.teamId
        ) {
          Toast("请选择所属团队！");
          document.documentElement.scrollTop = 0;
        } else {
          Toast("请填写完整的报名信息!");
        }
      },
      //表单验证通过时的提交
      onSubmit() {

        const originData = this.formData;
        const matchInfo = this.matchInfo;
        const needPic = this.needPic;
        const uploader = this.uploader;
        let postData = [];
        originData.forEach((item, index) => {
          let addressArray = item.areaString.split("/");
          item.matchName = this.matchName;
          item.province = addressArray[0];
          item.city = addressArray[1];
          item.county = addressArray[2];
          item.addressArray = addressArray;
          item.userId = this.userId;
          item.teamId = this.teamId;
          item.teamName = this.teamName;
          item.url = this.uploader && this.uploader[0] && this.uploader[0].url;
          if (item && item.birthday === "") {
            Toast.fail("请选择您的出生年月日，方便后期保险的购买！");
            this.canSubmitForm = false;
          } else {
            this.canSubmitForm = true;
          }

          if (item.number && item.type === "身份证") {
            let birthdayNum = this.formatSfzNumber(item.number);
            if (birthdayNum !== item.birthday) {
              Toast("检测到您填写的出生年月日与身份证上不相符，你仔细检查修改后再提交！");
              this.canSubmitForm = false;
            } else {
              this.canSubmitForm = true;
            }
          }
          //邀请码
          if (this.projectCode) {
            item.code = this.projectCode;
          }
          postData.push(item);

        });

        //需提交完赛证明
        if (matchInfo.type === 1 && needPic && uploader && uploader.length < 1) {
          Toast.fail("全程马拉松赛事，必须提交近期内完赛证明！");
          return false;
        }

        //团队赛，只能队长报名
        if (this.refuseSubmit) {
          Toast("该赛事限制只能由团队队长报名，请联系队长<<" + this.teamOwnerName + ">>来帮团队报名！");
          return false;
        }

        //团队赛人数校验
        if (this.type === 2 && postData.length !== this.teamNumber) {
          Toast("该项目一共需要" + this.teamNumber + "人参赛，请认真填写写完整的报名信息，检查出生年月日是否与身份证号码匹配！");
          this.canSubmitForm = false;
        }

        this.disabledSubmit = true;

        this.canSubmitForm && postData && postData.length > 0 && fetchHttp("marathon/signUp/bathProject", postData, "POST", "showError")
          .then((res) => {
            if (res && res.code === 0) {
              setTimeout(() => {
                this.disabledSubmit = false;
              }, 3500)

              if (res.data) {
                if (!this.price || this.price === "0" || this.price === "0.00") {
                  Toast.success(
                    "报名成功！"
                  );
                  // 跳转到我的赛事页面
                  setTimeout(() => {
                    window.location.href = "myGame"; //personalSignUp.html
                  }, 2000);
                } else {

                  if (res.data.ids && res.data.ids.length > 0) {
                    Toast.success("提交成功，请尽快付款！");
                    // 跳转到我的支付页面
                    setTimeout(() => {
                      let url = `pay?id=${res.data.ids.join(",")}&matchName=${this.matchName
                        }&price=${this.price * this.formData.length}&endTime=${this.endTime
                        }`;
                      window.location.href = url;
                    }, 1500);
                  } else if (res.data.errorList && res.data.errorList.length > 0) {
                    Dialog.alert({
                      title: "姓名和身份证号码校验失败",
                      message: res.data.errorList.join('，'),
                    })
                  }
                }
              } else {
                Toast.fail(res.message);
              }
            } else {
              setTimeout(() => {
                this.disabledSubmit = false;
              }, 3500)
              if (res.message === "该比赛已经报名过" && res.code === 200004) {
                Dialog.confirm({
                  title: " 重复报名",
                  message: '系统检测到您的手机号或者身份证号码已经参加了该赛事，不允许重复报名！',
                }).then(() => {
                  window.location.href = "myGame";
                })
              } else if (res.code === 200022 && res.message === "您不符合该赛事年龄要求!") {
                Toast.fail(res.message + '年龄要求在' + this.ageMin + '~' + this.ageMax + '之间！');
              } else {
                Toast.fail(res.message);
              }
            }
          });




      },
      getGameDetail() {
        let id = getQueryString("matchId");
        let index = getQueryString("index");
        if (id) {
          //获取项目信息
          fetchHttp("marathon/project/information", { matchId: id }, "GET").then(
            (res) => {
              //判断接口状态
              if (res && res.code === 0) {
                //判断是否有项目详情
                if (res.data && res.data[index]) {

                  let informationData = res.data[index];
                  let type = informationData.type;
                  let sexIdsArray = informationData.sexIds && informationData.sexIds.split(",");
                  let isNeedCertificate = informationData.isNeedCertificate;
                  console.log("项目信息：", informationData);
                  this.matchInfo = informationData;
                  this.matchTime = formatTime(informationData.matchTime);
                  this.type = type;
                  this.teamNumber = informationData.teamNumber;
                  this.needPic = isNeedCertificate === 1 ? true : false;
                  this.ageMax = informationData.ageMax;
                  this.ageMin = informationData.ageMin;

                  if (type === 1) {
                    //this.getOriginData();
                    //弹出邀请码的框
                    if (this.projectCode) {
                      this.showProjectCodeBox();
                    }
                  } else {
                    //如果有所属的团险信息，要选择团队信息
                    let teamIds = informationData.teamIds;
                    //判断团体赛是否限制队长报名
                    let onlyTeamOwner =
                      informationData && informationData.isTeam === "1" ? true : false;

                    this.teamIds = informationData.teamIds;
                    this.onlyTeamOwner = onlyTeamOwner;

                    if (teamIds) {
                      this.getTeamListData(teamIds);
                    }
                    //取几个人的值，来固定报名人数
                    this.formData = new Array(informationData.teamNumber)
                      .fill()
                      .map((v, i) => {
                        return {
                          index: i,
                          name: "",
                          sex: (sexIdsArray && sexIdsArray[i]) || "0",
                          readOnlySex: sexIdsArray[i] !== "0" ? true : false,
                          tel: "",
                          type: "",
                          pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                          showType: false,
                          showDressSize: false,
                          showArea: false,
                          showPicker: false,
                          disabledNumber: false,
                          disableBirthday: false,
                          disabledName: false,
                          disabledSex1: false,
                          disabledTel: false,
                          number: "",
                          dressSize: "",
                          areaString: "",
                          address: "",
                          matchId: getQueryString("matchId"),
                          projectId: getQueryString("projectId"),
                          url: "",
                          teamId: "",
                          teamName: "",
                        };
                      });
                  }
                } else {
                  Toast("没有找到相关赛事!");
                  setTimeout(() => {
                    history.back();
                  }, 1500);
                }
              }
            }
          );
        } else {
          Toast("没有找到相关的赛事项目!");
        }
      },

      getOriginData(callback) {
        //获取基本信息
        fetchHttp("marathon/getUserInfo", { id: this.userId }, "GET").then(
          (res) => {
            if (res && res.code === 0) {
              let data = res.data;
              let myInfo = this.formData[0];
              if (data.type === '身份证' && data.name && data.number) {
                Dialog.confirm({
                  title: "重要：请确认您的信息是否正确",
                  message: `为保证报名信息的正确性，我们已经接入实名认证系统，请认真检查以下实名信息; <br/>姓名：${data.name} ； <br/>身份证号码 ${data.number}`,
                  confirmButtonText: '去修改',
                  cancelButtonText: '信息无误'
                }).then(() => {
                  window.location.href = "myInfo";
                })
              }
              if (data) {
                //处理省市区
                if (data.province && data.city && data.county) {
                  myInfo.areaString =
                    data.province + "/" + data.city + "/" + data.county;
                }
                //处理完赛证明
                this.uploader = data.url ? [{ url: data.url }] : [];
                //处理性别
                data.sex = String(data.sex);
                Object.assign(myInfo, data);


                this.formData && this.formData.length > 0 && this.formData.map((item, index) => {
                  //如果有手机和身份证号码，不可编辑
                  if (item.name) {
                    this.formData[0].disabledName = true;
                  }

                  if (item.type) {
                    this.formData[0].pattern = this.allPattern[item.type];
                  }

                  if (item.tel) {
                    this.formData[0].disabledTel = true;
                  }

                  if (item.number) {
                    this.formData[0].disabledNumber = true;
                  }

                  if (item.sex !== "null") {
                    this.formData[0].disabledSex1 = true;
                  }


                });

              }
            }
            if (callback) {
              callback(res);
            }
          }
        );
      },
      onAgree(e) {
        this.showAgree = false;
        this.getOriginData();
        if (this.matchInfo && this.matchInfo.type === 2) {
          this.showGetMyInfo = true;
        }
      },
      oneKeyInfo(e) {
        this.getOriginData((res) => {
          this.showGetMyInfo = false;
        });
      }
    },
  };
</script>

<style scope lang="less">
  .redColor {
    color: red;
  }

  .mr5 {
    margin-right: 5px;
  }

  .matchInfoBox li {
    font-size: 14px;
    line-height: 30px;
  }

  body {
    position: relative;
  }

  .ml10 {
    margin-left: 10px;
  }

  .agreeBox {
    width: 100%;
    padding: 0px 10px 20px 10px;
    color: #000;
  }

  .agreeBox .van-checkbox__label {
    color: #000;
  }

  .agreeBox a {
    color: #1890ff;
  }

  .fixedBottomBar {
    width: 100%;
    height: 50px;
    background: #fff;
    position: fixed;
    bottom: 0px;
    left: 0;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #ddd;
    padding: 0 10px;
  }

  .submitBtn {
    height: 40px;
    padding: 0 30px;
    border-radius: 0;
  }

  .addPeopleBox {
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
  }

  .formItemBox {
    width: 100%;
    border-bottom: 1px solid #ddd;
    margin-bottom: 15px;
  }

  /*遮罩层显示时body的样式*/
  .notScroll {
    overflow: hidden;
  }

  .game-card {
    background: #fff;
    margin-bottom: 10px;
    padding: 10px;
  }

  .mt-10 {
    margin: -10px 0 5px 0 !important;
  }

  .gameSignUp {
    color: #333333;
    background: #efefef;
  }

  .signUpTitle {
    padding: 10px 0;
    font-size: 16px;
    margin: 0;
  }

  .van-submit-bar {
    border-top: 1px solid #efefef;
  }

  .van-submit-bar__text {
    text-align: left;
  }

  .readAgree {
    margin-left: 15px;
    color: #1890ff;

    text-decoration: underline;
  }

  .baomTitle {
    font-size: 14px;
    margin-left: 10px;
    color: red;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
  }

  .delBaoming {
    font-size: 20px;
    margin-right: 10px;
    line-height: 10px;
  }

  .bigTips .van-field__label {
    font-size: 14px;
    color: #ee0a24;
    font-weight: bold;
  }

  .baomInfoTitle {
    padding: 5px;
    margin: 0 0 5px 5px;
  }

  .font20 {
    font-size: 20px;
  }
</style>
<!-- 邀请码 -->
<!-- http://www.ccfmty.com/active/gameSignUp?matchId=281&matchName=2023%E9%95%BF%E6%98%A5%E9%A9%AC%E6%8B%89%E6%9D%BE&projectId=528&index=1&online=0&endTime=2023-05-01&price=120&projectCode=YQJTsbdZFS -->